import { createAction } from '@reduxjs/toolkit';

export const requestViewApprovalCount = createAction('request/viewApprovalCount');
export const requestViewApprovalMembers = createAction('request/viewApprovalMembers');
export const requestViewApprovals = createAction('request/viewApprovals');
export const requestUpdatePostStatus = createAction('request/updatePostStatus');
export const requestUpdateCommentStatus = createAction('request/updateCommentStatus');
export const requestUpdateAllPostStatus = createAction('request/updateAllPostStatus');
export const requestUpdateAllCommentStatus = createAction('request/updateAllCommentStatus');
export const requestViewApprovalsForUser = createAction('request/viewApprovalsForUser');
export const requestEvaluateSupportConversation = createAction('request/checkForSupportConversation');
